import { IComponentOptions } from "angular";
import { MachineDetailPartsComponentController } from "./controller";

export const vsName = "machineDetailPartsComponent";

export const machineDetailPartsComponentOptions: IComponentOptions = {
  controller: MachineDetailPartsComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    machineParts: "<",
  },
};
